import React, { Component, Fragment, PropsWithChildren } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationPaths } from './ApiAuthorizationConstants';

const authenticatedView = (profilePath: string, logoutPath: string, logoutState: { local: boolean }) => {
  return (<Fragment>
    <NavItem>
      <NavLink tag={Link} className="text-light" to="/admin">Admin Dashboard</NavLink>
    </NavItem>
    <NavItem>
      <NavLink tag={Link} className="text-light" to={profilePath}>Profile</NavLink>
    </NavItem>
    <NavItem>
      <NavLink replace tag={Link} className="text-light" to={logoutPath} state={logoutState}>Logout</NavLink>
    </NavItem>
  </Fragment>);
}

export function LoginMenu(props: PropsWithChildren<{ isAuthenticated?: any; }>){
  if (props.isAuthenticated) {
    const profilePath = `${ApplicationPaths.Profile}`;
    const logoutPath = `${ApplicationPaths.LogOut}`;
    const logoutState = { local: true };
    return authenticatedView(profilePath, logoutPath, logoutState);
  }
  else{
    return <></>
  }
}
